import { createFileRoute } from '@tanstack/react-router';
import { ensureLoaded } from '@/lib/ensure-loaded';
import { campaignsQuery } from '@/services/playbooks';
import { reviewQueueQuery } from '@/services/review';
import { myRoleQuery } from '@/services/team-members';
import { isAgencyRole } from '@/features/team/role-model';
import { CampaignsPage } from '@/features/campaigns/campaigns-page';

export const Route = createFileRoute('/_authed/campaigns')({
  // Her role first: an Agency seat's role has no Campaigns page, so it reads nothing and sees the role card. Then
  // both reads in parallel, before the page renders (a read only cancelled is waited for again: `ensureLoaded`).
  loader: async ({ context: { queryClient, team } }) => {
    if (!team) return;
    const mine = await queryClient.ensureQueryData(myRoleQuery(team.id)).catch(() => null);
    if (isAgencyRole(mine?.role)) return;
    await Promise.all([ensureLoaded(queryClient, campaignsQuery(team.id)), ensureLoaded(queryClient, reviewQueueQuery(team.id))]);
  },
  component: CampaignsPage,
});
